export default __webpack_public_path__ + "static/media/logo.da33c3e0.png";